export default __webpack_public_path__ + "static/media/S-007.097d8dbe.png";